import React from 'react'
import { Button } from 'reactstrap'
import { ArrowLeft } from 'react-feather'
import { useNavigate } from 'react-router-dom'


const NewBreadCrumbs = (props) => {
    const navigate = useNavigate()
    const { title } = props
    return (
        <div className='d-flex align-item-center'>
            <ArrowLeft type='button' style={{ marginRight: '45px', marginLeft: '10px' }} onClick={() => navigate(-1)}></ArrowLeft>
            {title ? <h2 className='  mb-1'>{title}</h2> : ''}
        </div>

    )
}

export default NewBreadCrumbs